import React from "react";
import { Container } from "reactstrap";
import { Notification } from "../../components/alerting-visitors/notification";
import "../../css/myestare.css";

function TrusteeRealEstateContent() {

  return (
    <div style={{ width: "1000px" }}>
      <div style={{ display: "flex", justifyContent: "" }}>
        <Container>
        <div style={{ marginTop: "30px" }}>
          <Notification />
        </div>
          
        </Container>
      </div>
    </div>
  );
}

export default TrusteeRealEstateContent;
